const BASE_DEV_WEB = "http://localhost:3003";
const BASE_PROD_WEB = "https://www.grepixit.com";

export const BASE_URL_WEB =
  process.env.NODE_ENV === "development" ? BASE_DEV_WEB : BASE_PROD_WEB;

export const websiteDetail = {
  title: "BidNRide",
  titleValue: "BidNRide",
  email: "reachus@grepixit.com",
  countryCode: "+91",
  mobile: "8860213347",
  phoneNumber: "+91-886-021-3347",
  sharedTitle: "BidNRide is a global transportation app developed by Grepix",
  quoteTitle: "BidNRide is a global transportation app developed by Grepix",
  link: "https://www.grepixit.com",
  linkText: "www.grepixit.com",
  paymentDescription: "BidNRide booking website",
  address: "E-30, 2nd Floor, Sector - 3, Noida, India - 201301",
  addressData: "E-30, 2nd Floor, Sector - 3, Noida, India - 201301",
  developed:"Grepix"
};

export const websiteDetailUrl = {
  annoucement: `${BASE_URL_WEB}/announcement-detail`,
  article: `${BASE_URL_WEB}/article-detail`,
  blog: `${BASE_URL_WEB}/blog-detail`,
  imageURL: process.env.REACT_APP_IMAGE_URL,
  notification:`${process.env.REACT_APP_CARD_URL}/backend/notification/send`
};

export const websiteSocialLinks = {
  facebook: "https://www.facebook.com/Grepix/",
  twitter: "https://x.com/grepixit",
  linkedin: "https://in.linkedin.com/company/grepix-infotech",
  instagram: "https://www.instagram.com/grepixinfotech/",
  youtube: "https://www.youtube.com/channel/UCZF8d-0cbvAJGd_75nl9vcg",
  tiktok: "",
  pinterest: "https://in.pinterest.com/",
  android:
    "https://play.google.com/store/apps/details?id=com.grepix.driverapp",
  ios: "https://apps.apple.com/in/app/bid-n-ride/id1583724412",
};

export const DEFAULT_FIREBASE_PASSWORD = "testtest";
export const DEFAULT_FIREBASE_PATH = "@indriver.com";

export const CITY_ID = process.env.REACT_APP_CITY_ID;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const DISTANCE_MATRIX_URL = process.env.REACT_APP_DISTANCE_MATRIX_URL2;
export const PUSH_NOTIFICATION_URL = "https://indriver.stitchmyapp.com/indriver1.0/webservices/push/driver-android-ios-push-notification";
export const NOTIFICATION_URL = process.env.REACT_APP_NOTIFICATION_URL;
export const MAP_ROUTE_URL = process.env.REACT_APP_MAP_URL;
export const BACKEND_IMAGE_URL = process.env.REACT_APP_BACKEND_IMAGE_URL;